var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 1.667A8.326 8.326 0 0 0 1.667 10 8.326 8.326 0 0 0 10 18.333 8.326 8.326 0 0 0 18.333 10 8.326 8.326 0 0 0 10 1.667zm4.167 11.325-1.175 1.175L10 11.175l-2.992 2.992-1.175-1.175L8.825 10 5.833 7.008l1.175-1.175L10 8.825l2.992-2.992 1.175 1.175L11.175 10l2.992 2.992z"
})));
export default SvgCancel;